import React from 'react';
import { shape, string } from 'prop-types';
import classnames from 'classnames';
import colornames from '../../lib/colornames';
import Action from '../buybox/actions/action';

import IconFactory from '../icons/factory-builder';
import labelToProps from '../styled-label/label-to-props';
import { StyledLabel } from '@vpp-frontend-components/styled-label';
import withMappedProps from '../../utils/withMappedProps';
import { serializeLabel } from '../../utils/label-utils';

const LabelComponent = withMappedProps(StyledLabel)(labelToProps);

const namespace = 'ui-pdp-vehicle-inspection-attribute';

const VehicleInspectionAttribute = ({ description, label, icon, icon_badge, action }) => {
  const actionProps = action && {
    ...action,
    actionType: action.action_type,
    hierarchy: 'quiet',
    size: 'small',
  };

  return (
    <div key={serializeLabel(label.text)} className={`${namespace}__spec`}>
      <div aria-hidden="true" className={`${namespace}__icon`}>
        {IconFactory(icon.id, classnames(colornames(icon.color)))}
      </div>
      <LabelComponent className={`${namespace}__spec_text`} label={label} />
      {icon_badge && IconFactory(icon_badge.id, classnames(colornames(icon_badge.color), `${namespace}__icon-badge`))}
      <div className={`${namespace}__spec_description`}>
        <LabelComponent label={description} />
        {action && <Action {...actionProps} className={`${namespace}__spec_button`} />}
      </div>
    </div>
  );
};

VehicleInspectionAttribute.propTypes = {
  description: shape({
    text: string.isRequired,
    color: string,
    font_size: string,
    font_family: string,
  }),
  label: shape({
    text: string.isRequired,
    color: string,
    font_size: string,
    font_family: string,
  }),
  icon: shape({
    id: string,
    color: string,
    size: string,
  }),
  icon_badge: shape({
    id: string,
    color: string,
    size: string,
  }),
  action: shape({
    type: string,
    label: shape({
      text: string.isRequired,
    }),
  }),
};

VehicleInspectionAttribute.defaultProps = {
  description: {},
  label: {},
  icon: {},
};

export default React.memo(VehicleInspectionAttribute);
